import React from 'react';

const About = () => {
  return (
    <div>
      <div className="w3-animate-opacity">
        <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/>
        <h1 className='title'>ABOUT ME</h1>
        <p>I am Michael Rodriguez, and I am a university student majoring in cybersecurity
          with an emphasis in computer science. With knowledge on several programming
          languages, frameworks, developer tools, and operating systems, I can help contribute
          to company growth and expand my skills along the way.
        </p>
      </div>

      <br/> <br/>
      <hr/>

      <div className="w3-animate-opacity">
        <br/> <br/> <br/> <br/>
        <h1 className='title'>EDUCATION</h1>
        <h2>Bachelor of Science in Cybersecurity (Computer Science Emphasis)</h2>
        <p><b>School - </b> University of Missouri-St. Louis <br/>
          <b>Expected Graduation Date - </b> May 2026 <br/>
          <b>GPA - </b> 3.7
        </p>
      </div>

      <br/> <br/>
      <hr/>

      <div className="w3-animate-opacity">
        <br/> <br/> <br/> <br/>
        <h1 className='title'>TECHNICAL SKILLS</h1>
        <h2>Programming Languages</h2>
        <ul>
          <li>C <i className="devicon-c-plain"></i></li>
          <li>C++ <i className="devicon-cplusplus-plain"></i></li>
          <li>Java <i className="devicon-java-plain"></i></li>
          <li>HTML <i className="devicon-html5-plain"></i></li>
          <li>CSS <i className="devicon-css3-plain"></i></li>
          <li>JavaScript <i className="devicon-javascript-plain"></i></li>
          <li>Shell <i className="devicon-bash-plain"></i></li>
        </ul>
        <h2>Developer Tools</h2>
        <ul>
        <li>GitHub <i className="devicon-github-original"></i></li>
          <li>GitLab <i className="devicon-gitlab-plain"></i></li>
          <li>Node.js <i className="devicon-nodejs-plain"></i></li>
          <li>Insomnia <i className="devicon-insomnia-plain"></i></li>
          <li>Linux Terminal <i className="devicon-linux-plain"></i></li>
        </ul>
        <h2>IDEs and Text Editors</h2>
        <ul>
          <li>IntelliJ <i className="devicon-intellij-plain"></i></li>
          <li>WebStorm <i className="devicon-webstorm-plain"></i></li>
          <li>Visual Studio Code <i className="devicon-vscode-plain"></i></li>
          <li>GNU nano <i className="devicon-nano-plain"></i></li>
          <li>Vim <i className="devicon-vim-plain"></i></li>
        </ul>
        <h2>Frameworks</h2>
        <ul>
          <li>NIST</li>
          <li>ISO/IEC 27000</li>
          <li>React.js <i className="devicon-react-original"></i></li>
          <li>Express.js <i className="devicon-express-original"></i></li>
        </ul>
        <h2>Operating Systems</h2>
        <ul>
          <li>Windows (11, 10, 7, XP) <i className="devicon-windows11-original"></i></li>
          <li>Linux (Ubuntu, Kali) <i className="devicon-ubuntu-plain"></i><i className="devicon-kalilinux-original"></i></li>
        </ul>
        <br/> <br/> <br/> <br/> <br/>
      </div>
    </div>
  );
};

export default About;
